const gsapController = async function () {
    const numbersContent = document.querySelector(".numbers-content") !== null;
    const animateHeading = document.querySelector(".animate-heading") !== null;
    const verticalSlider = document.querySelector(".vertical-animation-slider") !== null;
    const headingContentSlider = document.querySelector(".heading-content-slider") !== null;
    const textFlip = document.querySelector(".text-flip") !== null;
    const animateHeadingColor = document.querySelector(".animate-heading-color") !== null;
    const flowContentSvg = document.querySelector(".flow-content-svg") !== null;

    if ( numbersContent || animateHeading || verticalSlider || headingContentSlider || textFlip || animateHeadingColor || flowContentSvg) {
        let gsap = await (await import('gsap')).default;

        let AnimatedSection = await (await import('./gsap/text-flip')).default;
        AnimatedSection(gsap);

        // ScrollTrigger
        if ( numbersContent || animateHeading || verticalSlider || headingContentSlider || animateHeadingColor || flowContentSvg) {
            let ScrollTrigger = await (await import('gsap/ScrollTrigger')).default;
            gsap.registerPlugin(ScrollTrigger);

            if ( numbersContent ) {
                let AnimatedSection = await (await import('./gsap/numbers-content')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
            if ( animateHeadingColor ) {
                let AnimatedSection = await (await import('./gsap/animate-heading-color')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
            if ( animateHeading ) {
                let SplitText = await (await import('gsap/SplitText')).default;
                gsap.registerPlugin(SplitText);
                
                let AnimateText = await (await import('./gsap/animate-text')).default;
                AnimateText(gsap, ScrollTrigger,SplitText);
            }
            if ( verticalSlider ) {
                let VerticalAnimationSlider = await (await import('./gsap/vertical-animation-slider')).default;
                VerticalAnimationSlider(gsap, ScrollTrigger);
            }
            if (headingContentSlider) {
                const headingContentSliderModule = (await import('./gsap/heading-content-slider')).default;
                headingContentSliderModule(gsap, ScrollTrigger);
            }
            if (flowContentSvg) {
                let FlowContentSvg = await (await import('./gsap/flow-content-svg')).default;
                FlowContentSvg(gsap, ScrollTrigger);
            }
        }
    }
};

export const init = gsapController;